import { cn, cssVar } from '@/design-system';
import { syncLabel, useSyncState } from '@/shared/offline';

/**
 * De synchronisatiestatus in de donkere kopbalk van Mijn dag.
 *
 * Offline is neutraal/amber, nooit rood (principe 1); alleen een echt conflict
 * kleurt rood, want dat vraagt om een beslissing. De pulserende stip is de enige
 * animatie in het product.
 */
export function SyncPill() {
    const { state } = useSyncState();

    const tone = state.conflictCount > 0 ? 'danger' : state.online ? 'accent' : 'warn';
    const dotColor =
        tone === 'danger' ? cssVar.danger : tone === 'warn' ? cssVar.warnField : cssVar.accent;

    return (
        <span
            aria-live="polite"
            className={cn(
                'inline-flex items-center gap-[7px] rounded-[20px] border px-3 py-[7px]',
                tone === 'warn'
                    ? 'border-[var(--warn-on-dark-border)] bg-[var(--warn-on-dark-surface)]'
                    : 'border-[var(--ink-500)] bg-transparent',
            )}
        >
            <span
                aria-hidden="true"
                className={cn(
                    'h-[7px] w-[7px] shrink-0 rounded-full',
                    tone === 'accent' && 'animate-[skpulse_2s_infinite]',
                )}
                style={{ background: dotColor }}
            />
            <span
                className={cn(
                    'whitespace-nowrap text-[12px]',
                    tone === 'warn' ? 'text-[var(--warn-field)]' : 'text-[var(--text-on-dark-2)]',
                )}
            >
                {syncLabel(state)}
            </span>
        </span>
    );
}
